import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=437d7cc0"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437d7cc0')) {
      api.createRecord('437d7cc0', component.options)
    } else {
      api.reload('437d7cc0', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=437d7cc0", function () {
      api.rerender('437d7cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/subscription/Detail.vue"
export default component.exports